import React from 'react';
import { Page } from '../Components/Page';

export const NotFoundPage = () => <Page title="Page Not Found" />;
